import { createContext, useContext, useMemo } from "react";
import { translations } from "./translations";

const LangContext = createContext(null);

// Korean toggle removed per product decision — site is English-only.
// The provider is kept so existing components using `useLang().t` keep working.
export function LanguageProvider({ children }) {
  const value = useMemo(() => ({ lang: "en", t: translations.en }), []);
  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
}

export function useLang() {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
}
